export default "__VITE_ASSET__ZWv9_Wah__"